import { createContext, useContext } from "react";

import invitationService from "../../../clientServices/invitationService";

type InvitationService = typeof invitationService;

const InvitationServiceContext = createContext<InvitationService>(invitationService);

export const InvitationServiceProvider = InvitationServiceContext.Provider;

export function useInvitationService() {
    return useContext(InvitationServiceContext);
}
